import React from 'react'
import { Button, Dropdown, Confirm, Form, Header, Icon, Message, Dimmer, Loader, Tab } from 'semantic-ui-react'
import { inlineStyle } from '../../styles/custom'
import Details from './subject/details'
import { languages } from '../../constants'
import PermissionsManager from '../PermissionsManager'

const renderPanes = (obj, onChange) => {
  return languages.map((language) => {
    const attrs = { obj: obj, language: language, onChange: onChange }

    return {
      menuItem: language.label,
      render: () => <Tab.Pane key={language.code} attached={false}><Details {...attrs} /></Tab.Pane>
    }
  })
}

const renderSubjects = (subjects) => {
  let _subjects = [{ value: null, text: '--' }]

  subjects.forEach(subject => {
    _subjects.push({value: subject.id, text: subject.detail.title})
  })

  return _subjects
}

const SubjectForm = ({ obj, languages, subjects, status, onChange, onSubmit, onDelete }) => {
  if (status.loading)
    return (
      <Dimmer active inverted>
        <Loader inverted>Chargement</Loader>
      </Dimmer>
    )
  return (
    <Form>
      <Header>Sujet{status.isNew ? ' : Création' : ' : Édition'}</Header>
      {status.error ? <Message negative><Message.Header>Erreur</Message.Header ><p>{status.message}</p></Message > : null}
      {!status.error && status.message ? <Message info><p>{status.message}</p></Message> : null}

      <Form.Field>
        <label>Email</label>
        <input placeholder="Email" id="email" value={obj.email ? obj.email : ''} onChange={onChange} />
      </Form.Field>

      <Form.Field>
        <label>Sujet parent (optionnel)</label>
        {
          subjects.loading ? <div>Chargement des sujets</div> :
            <Dropdown placeholder='Sélectionnez un sujet parent' fluid selection closeOnChange id='parent_id' value={obj.parent !== null && obj.parent !== undefined ? obj.parent.id : obj.parent_id !== null && obj.parent_id !== undefined ? obj.parent_id : 0 } options={renderSubjects(subjects.getMainSubjects)} onChange={(param, data) => onChange(param, data, 'dropdown')} />
        }
      </Form.Field>

      <Tab menu={{ pointing: true }} panes={renderPanes(obj, onChange)} />

      <br /><br />

      <PermissionsManager hasPermissions={['create_subject', 'update_subject']}>
        {status.loading ? <Button type='submit' color='olive' loading></Button> :
          <Button type='submit' color='olive' floated='left' onClick={onSubmit}><Icon name="save" /> Sauvegarder</Button>
        }
      </PermissionsManager>
      <PermissionsManager hasPermissions={['delete_subject']}>
        {!status.isNew ? (
          <div>
            <Button type='submit' color='red' floated='right' onClick={(event, data) => { onDelete(event, { confirm: true }) }}><Icon name="delete" /> Suppression</Button>
          </div>
        ) : null}
      </PermissionsManager>
      <Confirm content='Êtes-vous sûr(e) de vouloir supprimer ce sujet ? Cette action est définitive.' open={status.deletion.confirm} onCancel={(event, data) => { onDelete(event, { confirm: null }) }} onConfirm={(event, data) => { onDelete(event, { confirm: false }) }} style={inlineStyle.modal} />
    </Form>
  )
}

export default SubjectForm



// WEBPACK FOOTER //
// ./src/components/form/Subject.js